import { Filter } from 'src/utils/composeFilter.ts';

export const isPressureDependentSelected = (filter: Filter) => Array.isArray(filter.Type) &&
    filter.Type.includes('@no') && !filter.Type.includes('@yes');
